import React from "react";

type Classification = "agreement" | "ai_only" | "report_only";

// C2 monochrome: one hue + neutrals, distinguished by fill / solid / dashed.
// The text label always carries the meaning; color only reinforces it.
const BADGE_STYLES: Record<Classification, { className: string; label: string }> = {
  agreement: {
    className: "bg-signal-tint text-signal-text-tint border border-signal-stroke",
    label: "Agree",
  },
  ai_only: {
    className: "bg-surface-2 text-fg-muted border border-border-strong",
    label: "AI Only",
  },
  report_only: {
    className: "bg-transparent text-fg-dim border border-dashed border-border-strong",
    label: "Rpt Only",
  },
};

interface ClassificationBadgeProps {
  classification: Classification;
}

const ClassificationBadge: React.FC<ClassificationBadgeProps> = ({ classification }) => {
  const style = BADGE_STYLES[classification];
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide ${style.className}`}
    >
      {style.label}
    </span>
  );
};

export default ClassificationBadge;
